import React from 'react';
import { CssBaseline, ThemeProvider } from "@mui/material";
import { getTheme } from "./colors";
import { router } from "./router/router";
import { RouterProvider } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { ToastContainer } from "react-toastify";
import { CalculatorModalProvider } from "./contexts/CalculatorModalContext";

const barekamTheme = getTheme();

function App() {
    return (
        <ThemeProvider theme={barekamTheme}>
            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || "536992742314-cfa9k47k18betnto4kknm9q25ijmp9qd.apps.googleusercontent.com"}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <CalculatorModalProvider>
                        <CssBaseline enableColorScheme={true} />
                        <RouterProvider router={router} fallbackElement={<p>Initial Load...</p>} />
                    </CalculatorModalProvider>
                </LocalizationProvider>
            </GoogleOAuthProvider>
            <ToastContainer />
        </ThemeProvider>
    );
}

export default App;
